import { REALITY_FIELD_NAMES } from "../../../smartsetter-utils/filters-dialog/data"
import { sanitizeFilter } from "../../../smartsetter-utils/filters-dialog/filterSchema"
import { isPotentialTierId } from "../components/potentialTierConstants"
import { normalizeLeadCallActivityFilters } from "./leadCallActivityFilters"

export function serializeUploadedLeadListFilters(filters) {
  const mapped = filters.map((filter) => {
    const rest = sanitizeFilter(filter)
    if (
      rest.field === REALITY_FIELD_NAMES.LIKELIHOOD_TO_MOVE &&
      isPotentialTierId(rest.value)
    ) {
      return {
        field: REALITY_FIELD_NAMES.POTENTIAL_TIER,
        type: rest.type || "is",
        value: rest.value,
      }
    }
    return rest
  })
  return normalizeLeadCallActivityFilters(mapped)
}
